// For images
export const messagesImgsOpenTag = '{{<img>}}';
export const messagesImgsCloseTag = '{{</img>}}';

// For PDFs
export const messagesPdfOpenTag = '{{<pdf>}}';
export const messagesPdfCloseTag = '{{</pdf>}}';

// For generic files
export const messagesFileOpenTag = '{{<file>}}';
export const messagesFileCloseTag = '{{</file>}}';

// Create regex patterns using the tag constants and make them global
export const messagesImgsRegex = new RegExp(`${messagesImgsOpenTag}(.*?)${messagesImgsCloseTag}`, 'g');
export const messagesPdfRegex = new RegExp(`${messagesPdfOpenTag}(.*?)${messagesPdfCloseTag}`, 'g');
export const messagesFileRegex = new RegExp(`${messagesFileOpenTag}(.*?)${messagesFileCloseTag}`, 'g');

// Still supporting old image format
export const messagesOldImgRegex = /{{(?![<])([^}]*)}}/g;

export const getTextFromChatMessage = (text: string) => {
  if (!text) return '';
  return text
    .replace(messagesImgsRegex, '')
    .replace(messagesPdfRegex, '')
    .replace(messagesFileRegex, '')
    .replace(messagesOldImgRegex, '')
    .trim();
};

export const getImageFromChatMessage = (text: string) => {
  if (!text) return undefined;

  messagesImgsRegex.lastIndex = 0;
  messagesOldImgRegex.lastIndex = 0;

  // Try new format first
  const newFormatMatch = messagesImgsRegex.exec(text);
  if (newFormatMatch?.[1]) {
    return newFormatMatch[1];
  }

  // If no match in new format, try old format
  const oldFormatMatch = messagesOldImgRegex.exec(text);
  return oldFormatMatch?.[1];
};

export const getPdfFromChatMessage = (text: string) => {
  if (!text) return undefined;

  messagesPdfRegex.lastIndex = 0;

  const match = messagesPdfRegex.exec(text);
  return match?.[1];
};

export const getFileFromChatMessage = (text: string) => {
  if (!text) return undefined;

  messagesFileRegex.lastIndex = 0;

  const match = messagesFileRegex.exec(text);
  return match?.[1];
};

export enum ReceiverType {
  User = 'User',
  Organization = 'Organization',
}
